import {connect} from 'react-redux';
import {isLoadingSelector} from '../../modules/LoadingStatus';
import {
  voucherAvailableVouchersSelector,
  voucherComeFromSelector,
  voucherFilteredAvailableVouchersSelectorLazy,
} from '../../modules/Voucher';
import {
  fetchAvailableVouchers,
  setCurrentVoucherDetails,
} from '../../modules/Voucher/actions';
import Vouchers from './Vouchers';

const mapStateToProps = state => {
  return {
    isRefreshingAvailableVouchers: isLoadingSelector(
      state,
      'refreshAvailableVouchers',
    ),
    availabeVouchers: voucherAvailableVouchersSelector(state),
    comeFrom: voucherComeFromSelector(state),
    filteredAvailableVouchers:
      voucherFilteredAvailableVouchersSelectorLazy(state),
  };
};

const mapDispatchToProps = (dispatch: Function) => ({
  fetchAvailableVouchers: () => dispatch(fetchAvailableVouchers()),
  setCurrentVoucherDetails: (object: Object) =>
    dispatch(setCurrentVoucherDetails(object)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Vouchers);
